module.exports = __webpack_public_path__ + "static/media/about-shape.bd2847ac.png";